import { FileInput as BaseFileInput } from 'lp-components'
import { withFormikAdapter } from 'utils'

export default withFormikAdapter()(BaseFileInput)
